<ng-container *ngIf="pageContent$ | async as data">
  <digital-platform-dynamic-content-wrapper
    *ngFor="let config of data"
    [config]="config"
  ></digital-platform-dynamic-content-wrapper>
</ng-container>
